module.exports = __webpack_public_path__ + "static/media/map.4c9f18cf.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/map.mov
// module id = 207
// module chunks = 0